/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const PhoneNumberTypeSchema = z.enum(["DEFAULT", "PERSONAL_PRIMARY", "PERSONAL_WORK", "BUSINESS_PRIMARY", "BUSINESS_SUPPORT", "BUSINESS_SALES", "BUSINESS_OTHER"])
